/**
 * @Description 工具箱-标记-地图显示的Marker
 */

import { FC, forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { Form, Row, Col } from 'antd';
import { useMethods } from '@lhb/hook';
import { showMarker } from '@/common/utils/map';
import { layerHoverZIndex } from '../ts-config';
// import cs from 'classnames';
import styles from './index.module.less';
import IconFont from '@/common/components/IconFont';
import V2DetailItem from '@/common/components/Feedback/V2DetailItem';
import V2FormInput from '@/common/components/Form/V2FormInput/V2FormInput';

const LabelItem: FC<{ address: string; mapIns: any; handleRemove: any }> = ({
  address,
  mapIns,
  handleRemove
}) => {
  const [form] = Form.useForm();
  const [curVal, setCurVal] = useState<string>(address);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  useEffect(() => {
    setCurVal(curVal);
    form.setFieldValue('address', address);
  }, [address]);

  return <Form
    form={form}
    className={styles.labelFormCon}
    // onWheel={(e) => e.stopPropagation()}
  >
    <Row style={{ width: '100%' }} align='middle'>
      <Col span={isEdit ? 24 : 22}>
        <V2DetailItem
          label=''
          allowEdit
          value={curVal}
          tooltipConfig={{
            onOpenChange: (open: boolean) => {
              mapIns.setStatus({
                dragEnable: !open
              });
            }
          }}
          editConfig={{
            formCom: <V2FormInput
              name='address'
              focus={() => {
                mapIns.setStatus({
                  dragEnable: false
                });
              }}
              blur={() => {
                mapIns.setStatus({
                  dragEnable: true
                });
              }}
              formItemConfig={{
                style: {
                  marginTop: 0
                },
              }}
              config={{
                maxLength: 50,
                style: {
                  width: '260px'
                }
              }}/>,
            onCancel() {
              form.setFieldValue('address', curVal);
              setIsEdit(false);
              mapIns.setStatus({
                dragEnable: true
              });
            },
            onOK() {
              setCurVal(form.getFieldValue('address'));
              setIsEdit(false);
              mapIns.setStatus({
                dragEnable: true
              });
            },
            onClick() {
              setIsEdit(true);
            }
          }}
          detailItemStyle={{
            marginTop: 0
          }}
          valueStyle={{
            background: '#fff',
            marginTop: 0,
            color: '#222'
          }}
        />
      </Col>
    </Row>
    {
      isEdit ? <></> : <div className={styles.delCon} onClick={handleRemove}>
        <IconFont iconHref='icondelete' className='c-999 fs-12 mb-2'/>
      </div>
    }
  </Form>;
};

const MakeMarker: FC<any> = forwardRef(({
  mapIns,
}, ref) => {
  const dragPixelRef = useRef<any>(null); // marker 拖拽时pixel的缓存
  useImperativeHandle(ref, () => ({
    createMarker: methods.handleCreateMarker, // 创建标记Marker
  }));

  const methods = useMethods({
    handleCreateMarker: (markerOpts: any, address: string) => {
      const marker = new window.AMap.Marker(markerOpts);
      mapIns && mapIns.add(marker);
      showMarker(marker, <IconFont
        iconHref='iconic_biaoji'
        className='fs-26' />);
      // 生成label marker，没有把两个放在一起是因为marker的bubble为true，MarkerItem内部使用e.stopPropagation();e.preventDefault(); 没用
      const { position } = markerOpts || {};
      methods.handleCreateLabelMarker(position, address, marker);
    },
    handleCreateLabelMarker: (position, address, targetMarker: any) => {
      const marker = new window.AMap.Marker({
        position,
        anchor: 'top-left',
        offset: [6, 0],
        zIndex: layerHoverZIndex.markAddress,
        draggable: true,
      });
      /**
       * 参照以下文件实现，如此处有问题可前往该文件查看并对比，来解决问题
       * src/views/youth/pages/map/components/TopContent/Tools/DrawPoint/DrawPointTool/index.tsx
       */
      marker.on('dragstart', (e) => {
        dragPixelRef.current = new window.AMap.Pixel(e.target._points[0] - e.pixel.x, e.target._points[1] - e.pixel.y);
        marker.setOffset(dragPixelRef.current);
      });
      marker.on('dragend', (e) => {
        const markerLeftTop = [dragPixelRef.current.x + e.pixel.x, dragPixelRef.current.y + e.pixel.y];
        // 转换为经纬度坐标
        const lnglat = mapIns.containerToLngLat(new window.AMap.Pixel(markerLeftTop[0], markerLeftTop[1]));
        marker.setOffset(new window.AMap.Pixel(0, 0));
        marker.setPosition(lnglat);
      });

      mapIns && mapIns.add(marker);
      showMarker(marker, <LabelItem address={address} mapIns={mapIns} handleRemove={() => {
        mapIns.remove(marker);
        mapIns.remove(targetMarker);
      }}/>);
    }
  });
  return <></>;
});

export default MakeMarker;
